import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@nyce/admin-kit/styles.css';
import '@nyce/admin-kit/console.css';
import './admin.css';
import App from './App';
import { applyTheme } from './theme';

// Before the first render (no inline script in index.html): the stored theme goes on <html> so nothing flashes.
applyTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
